export default __webpack_public_path__ + "static/media/win.d3311dd0.svg";